import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Button, Row, Col } from "antd";
import styles from "./DashBoardMobile.module.scss";
import serviceStyles from "../../Header/Header.module.scss";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import { usersImage, backArrowIcon, rightArrow } from "../../../assets/images";
import EllipsisText from "../../../helpers/EllipsisText/EllipsisText";
import navigateAddServiceUser from "../../../helpers/navigateAddServiceUser";
import { usePersonSummaryCtx } from "../../../context/PersonSummaryContext";

const DashBoardMobileServiceUsers = () => {
  const { caregiverSummaryInfo } = usePersonSummaryCtx();
  const { serviceDataCtx } = useTripsCtx();
  const [serviceData] = serviceDataCtx;
  const history: any = useHistory();

  const handleBack = (): void => history.goBack();

  const handleAddServiceUser = (): void =>
    navigateAddServiceUser(
      serviceData,
      caregiverSummaryInfo.personId,
      history,
      "Dashboard"
    );

  return (
    <div className={styles.serviceContainer}>
      <Row>
        <Col span={24}>
          <Button type="link" className={styles.backBtn} onClick={handleBack}>
            <img src={backArrowIcon} alt="back button" />
            Back
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24} className={styles.dashBoardText}>
          Service Users
        </Col>
      </Row>
      {serviceData.map((user: any) => (
        <Link
          to={`/Dashboard/ManageServiceUsers/${user.personId}`}
          className={styles.customLink}
          key={user.personId}
        >
          <Row align="middle" className={styles.serviceRow}>
            <Col span={3}>
              {user.profileImageUrl !== null ? (
                <img
                  alt="User-Image"
                  src={user.profileImageUrl}
                  className={serviceStyles.serviceUsersImage}
                />
              ) : (
                <img
                  alt="Default-Image"
                  src={usersImage}
                  className={serviceStyles.serviceUsersImage}
                />
              )}
            </Col>
            <Col span={18} className={styles.serviceHeading}>
              <EllipsisText
                text={`${user.firstName} ${user.lastName} `}
                maxVisibleTextLength={20}
              />
            </Col>
            <Col span={3}>
              <Row justify="end">
                <Col>
                  <img alt="Right-Arrow" src={rightArrow} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Link>
      ))}
      <Row className={styles.addNewRow}>
        {serviceData.length === 0 && (
          <div className={serviceStyles.noUsersText}>
            No service users added.
          </div>
        )}
        {serviceData.length < 25 && (
          <div>
            <Button
              type="link"
              onClick={handleAddServiceUser}
              className={styles.addNewUserBtn}
            >
              <span className={styles.underlineText}>+ Add New</span>
            </Button>
          </div>
        )}
      </Row>
    </div>
  );
};
export default DashBoardMobileServiceUsers;
